// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"206":"ed864eab846654d2","373":"2c0f92a6b76bd0b3"}[chunkId] + ".js";
};